module.exports = __webpack_public_path__ + "static/media/eyeLotion.abef0c83.png";